import React from 'react'
import { Col, FlexboxGrid, Row } from 'rsuite'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import ProgressBar from '../../../components/progressBar/ProgressBar'

export default function ProgressDataCard({ schema, ...props }) {
  const { bgcolor } = props
  return schema ? (
    <Row style={{ marginTop: 10 }}>
      <FlexboxGrid
        align="middle"
        style={{
          borderStyle: 'solid',
          borderWidth: 'thin',
          borderColor: '#2da888',
          borderRadius: 10,
        }}
      >
        <FlexboxGrid.Item colspan={24} style={style}>
          <Row style={{ width: '100%', padding: 15 }}>
            <Col xs={6} sm={6} md={6} lg={6} align="right" style={{ color: '#FFFFFF' }}>
              <p style={{ padding: '5px 0px' }}>
                <b>{schema.label}</b>
              </p>
            </Col>
            <Col
              xs={18}
              sm={18}
              md={18}
              lg={18}
              align="right"
              style={{ backgroundColor: 'whitesmoke', borderRadius: 10 }}
            >
              <p style={{ padding: '5px 0px' }}>
                <b>{numberThousandSeparator(schema.value) || 0} บาท</b>
              </p>
            </Col>
          </Row>
        </FlexboxGrid.Item>
        <div
          style={{
            width: '100%',
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          {schema.datas?.map((item, index) => (
            <Row style={{ width: '100%', paddingTop: 10 }}>
              <Col xs={8} sm={8} md={8} lg={8} align="right">
                {item.label}
              </Col>
              <Col xs={16} sm={16} md={16}>
                <ProgressBar
                  key={index}
                  pgcolor={item.color}
                  completed={item.value}
                  bgcolor={bgcolor}
                />
              </Col>
            </Row>
          ))}
        </div>
      </FlexboxGrid>
    </Row>
  ) : (
    ''
  )
}

const baseStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const style = {
  backgroundColor: '#2da888',
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  ...baseStyle,
}
